export default "__VITE_ASSET__286142af__"